<template>
    <div>
        <vue-simple-spinner v-if="processing"></vue-simple-spinner>
        <notifications group="foo" />
        <div v-if="webinarProcessed">
            <div class="container mb-5" v-if="webinar.live_note">
                <p class="mb-0" v-html="webinar.live_note"></p>
            </div>
            <div v-if="isLive">
                <div class="jumbotron jumbotron-fluid jumbotron-home">
                    <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-9 col-embed">
                                    <div v-if="webinar.video_url" class="embed-responsive embed-responsive-16by9">
                                        <iframe class="embed-responsive-item" v-bind:src="webinar.video_url" allowfullscreen></iframe>
                                    </div>
                                    <div v-else>
                                        <h3>Prosimy odświezyć stronę</h3>
                                    </div>
                                </div>

                                <div class="col-md-3" id="chat-window">
                                    <chat :webinar_uuid="webinar_uuid" :asset_path="asset_path" :user_id="user_id" :chat_name="chat_name" :is_admin="is_admin"></chat>
                                </div>
                            </div>

                            <h1 v-html="webinar.title"></h1>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="jumbotron jumbotron-fluid jumbotron-home">
                    <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
                        <div class="container-fluid">
                            <div class="row">
                                <hr>
                                <div class="embed-responsive embed-responsive-16by9">
                                    <div class="card-img-overlay text-white text-sm-center display-2" style="padding-top:25%" id="vimeo-iframe" v-html="timer"></div>
                                </div>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Spinner from "vue-simple-spinner";

export default {
    props: ['webinar_uuid', 'user_id', 'is_admin', 'chat_name', 'asset_path'],
    components: {
        Spinner
    },
    data() {
        return {
            webinar: {},
            webinarProcessed: false,
            processing: true,
            timer: null,
            isMarked: false,
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.getWebinar();
            var self = this;
            if (self.timer != 'Zapraszamy') {
                setInterval(function () {
                    if (self.webinar) {
                        var diffInSeconds = Math.abs(new Date() - new Date(self.webinar.video_start_date)) / 1000;
                        var hours = parseInt(diffInSeconds / 60 / 60);
                        var minutes = parseInt(diffInSeconds / 60 % 60);
                        var seconds = parseInt(diffInSeconds % 60)
                        self.timer = self.formatHour(hours) + ':' + self.formatTime(minutes) + ':' + self.formatTime(seconds);
                        if (self.timer === '00:00:00' || new Date() > new Date(self.webinar.video_start_date)) {
                            self.timer = 'Zapraszamy';
                        }
                    }
                }, 1000);
            }
        });
    },
    computed: {
        isLive() {
            if(this.webinar.video_start_date && this.timer !== null ) {
                var date = new Date(this.webinar.video_start_date);
                if(new Date() >= date || this.timer < new Date()) {
                    if(this.isMarked === false) {
                        axios.post('/api/webinars/' + this.webinar.id + '/mark-attendance');
                        this.isMarked = true;
                    }

                    return true;
                }
            }

            return false;
        }
    },
    methods: {
        getWebinar() {
            axios.get('/api/webinars/get-by-uuid/' + this.webinar_uuid)
            .then(response => {
                this.webinar = response.data.data;
                this.webinarProcessed = true;
                this.processing = false;
            });
        },

        formatTime(time)
        {
            return ('0' + time).slice(-2);
        },

        formatHour(hours)
        {
            if(hours<10){
                return '0' + hours;
            }
            return hours;
        }
    }
}
</script>
